import { Component, AfterViewChecked, ChangeDetectorRef, ViewChild, AfterViewInit, TemplateRef, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { PopupService } from '../../../services/popup.service';
import Bootstrap from 'bootstrap/dist/js/bootstrap';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { PuntoapuntoPopupDTO } from '../../../models/puntoapunto-popup-dto';
import { FileService } from '../../../services/file.service';
import { Router } from '@angular/router';
import { CommercialConditionService } from '../../../services/commercial-conditions.service';
import { ModalStateService } from '../../../services/modal-state.service';

@Component({
  selector: 'app-popup-cc',
  templateUrl: './popup-cc.component.html'
})
export class PopupccComponent implements AfterViewInit, AfterViewChecked {

  @ViewChild('modalcc', { read: TemplateRef }) modalcc: TemplateRef<any>;
  private modalRef: NgbModalRef;
  routerUrl = '';

  constructor(private changeRef: ChangeDetectorRef, private modalService: NgbModal, private commConditionService: CommercialConditionService,
    private modalStateService: ModalStateService
  ) { }

  ngAfterViewInit(): void {

  }
  ngAfterViewChecked(): void { this.changeRef.detectChanges(); }

  showPopup() {


    if (this.modalStateService.modalIsOpen == false)
      this.openCentrado(this.modalcc, "lg");



  }

  // size = sm, md, lg y xl
  openCentrado(modal: any, size: string) {
    this.modalStateService.modalIsOpen = true;
    this.modalRef = this.modalService.open(modal, { centered: true, size: size });


  }
  closeModal() {

    if (this.routerUrl == '/home') {
      this.commConditionService.setData(true);
    } else {
      this.commConditionService.setData(false);
    }
    this.modalRef.close();
    this.modalStateService.modalIsOpen = false;
  }

}
